import React from "react";
import {Route, Switch} from "react-router-dom";
import Home from "./containers/Home";
import Settings from "./containers/Settings";
import NotFound from "./containers/NotFound";
import AuthenticatedRoute from "./components/AuthenticatedRoute";
import ChangePassword from "./containers/ChangePassword";
import Hqs from "./containers/Hqs";
import NewHqs from "./containers/NewHqs";

export default function Routes() {
    return (
        <Switch>
            <Route exact path="/">
                <Home/>
            </Route>
            <AuthenticatedRoute exact path="/settings">
                <Settings/>
            </AuthenticatedRoute>
            <AuthenticatedRoute exact path="/settings/password">
                <ChangePassword/>
            </AuthenticatedRoute>
            <AuthenticatedRoute exact path="/hqs/new">
                <NewHqs/>
            </AuthenticatedRoute>
            <AuthenticatedRoute exact path="/hqs/:hqsId">
                <Hqs/>
            </AuthenticatedRoute>
            {/* Finally, catch all unmatched routes */}
            <Route>
                <NotFound/>
            </Route>
        </Switch>
    );
}
